import { Box } from '@mui/material';
import { FC } from 'react';
import { DpContainer } from '@/components/blocks/DpContainer';
import { DpH2 } from '@/components/blocks/DpLibrary/DPText';
import { newMostTitleSX } from '@/components/blocks/NewMost/styles/typography';
import { DpIARecommendationBadge } from '@/components/content/CatalogEntryIARecommendation/parts/DpIARecommendationBadge';

type Props = {
	title: string;
	showRecommendationBadge?: boolean;
};

export const DpIARecommendationHeader: FC<Props> = ({ title, showRecommendationBadge }) => (
	<DpContainer withoutmargin>
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				flexWrap: 'wrap',
				gap: { xs: '8px', sm: '12px' },
				mb: { xs: '10px', sm: '20px' },
			}}
		>
			<DpH2 sx={newMostTitleSX(false)}>{title}</DpH2>
			{showRecommendationBadge ? <DpIARecommendationBadge /> : null}
		</Box>
	</DpContainer>
);
